import PlatformFilterOperator from "@mapmycustomers/shared/enum/PlatformFilterOperator";

import RecordsCadenceEffectivenessBand from "@app/types/dashboard/cards/recordsCadenceEffectiveness/RecordsCadenceEffectivenessBand";

/**
 * Platform `$filters` condition selecting the accounts in a single overdue band by
 * `cadenceDaysOut`. Bands are exclusive and inclusive-lower, matching the card face's
 * range aggregation: 30 → [30, 60), 60 → [60, 90), 90 → [90, ∞).
 */
const getBandCadenceRange = (band: RecordsCadenceEffectivenessBand) =>
  ({
    [RecordsCadenceEffectivenessBand.NINETY]: {
      [PlatformFilterOperator.GREATER_THAN_OR_EQUAL]: RecordsCadenceEffectivenessBand.NINETY,
    },
    [RecordsCadenceEffectivenessBand.SIXTY]: {
      [PlatformFilterOperator.GREATER_THAN_OR_EQUAL]: RecordsCadenceEffectivenessBand.SIXTY,
      [PlatformFilterOperator.LESS_THAN]: RecordsCadenceEffectivenessBand.NINETY,
    },
    [RecordsCadenceEffectivenessBand.THIRTY]: {
      [PlatformFilterOperator.GREATER_THAN_OR_EQUAL]: RecordsCadenceEffectivenessBand.THIRTY,
      [PlatformFilterOperator.LESS_THAN]: RecordsCadenceEffectivenessBand.SIXTY,
    },
  })[band];

export default getBandCadenceRange;
